import React, { useState } from 'react';
import { Card, Form, Input, Button, Alert, Space, message } from 'antd';
import { LockOutlined, SaveOutlined } from '@ant-design/icons';
import { adminAPI } from '../api/admin';

export default function ChangePasswordManager() {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleSave = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.error('رمز جدید و تکرار آن یکسان نیستند');
      return;
    }
    setSaving(true);
    try {
      const res = await adminAPI.changeMyPassword(values.currentPassword, values.newPassword);
      if (res.data.success) {
        message.success('رمز عبور با موفقیت تغییر کرد');
        form.resetFields();
      } else {
        message.error(res.data.message || 'خطا در تغییر رمز عبور');
      }
    } catch (e) {
      message.error(e?.response?.data?.message || 'رمز فعلی اشتباه است یا خطایی رخ داد');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <Alert
        type="warning"
        showIcon
        icon={<LockOutlined />}
        style={{ marginBottom: 20 }}
        message="امنیت حساب"
        description="رمز عبور پیش‌فرض (admin123) فقط برای اولین ورود است — حتماً آن را از همین‌جا تغییر بده."
      />

      <Card title={<Space><LockOutlined /><span>تغییر رمز عبور</span></Space>}>
        <Form form={form} layout="vertical" onFinish={handleSave} style={{ fontFamily: "'Vazirmatn', sans-serif" }}>
          <Form.Item
            name="currentPassword"
            label="رمز عبور فعلی"
            rules={[{ required: true, message: 'رمز فعلی را وارد کنید' }]}
          >
            <Input.Password style={{ direction: 'ltr' }} />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="رمز عبور جدید"
            rules={[{ required: true, message: 'رمز جدید را وارد کنید' }, { min: 6, message: 'حداقل ۶ کاراکتر' }]}
          >
            <Input.Password style={{ direction: 'ltr' }} />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="تکرار رمز عبور جدید"
            rules={[{ required: true, message: 'تکرار رمز را وارد کنید' }]}
          >
            <Input.Password style={{ direction: 'ltr' }} />
          </Form.Item>

          <Form.Item style={{ marginTop: 16 }}>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={saving} size="large">
              تغییر رمز عبور
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
